import sortBy from 'lodash/sortBy';
import { formatAddressSingleLine } from './addresses';

export const SORT_OPTIONS = ['Recommended', 'Distance'];

const formatLocationAddress = ({ location, country }) => {
  if (!location.store_address) return location;
  const {
    address_line1: address1,
    address_line2: address2,
    city,
    postal_code: postal,
    region_code: region,
  } = location.store_address;
  return {
    ...location,
    addressString: formatAddressSingleLine({
      countryCode: country,
      address: {
        address1,
        address2,
        city,
        postalCode: postal,
        region,
      },
    }),
  };
};

export const getLocations = ({
  country,
  postalCode,
  cachedQueries,
  locationsById,
  isConsolidated,
  consolidatedLocations,
  selectedOptionId,
  selectedOptionMethodKey,
  sortedBy,
}) => {
  if (isConsolidated) {
    const { [selectedOptionId]: { [postalCode]: locations } = {} } = consolidatedLocations;
    if (!locations) return undefined;

    const sortedLocations =
      sortedBy === 'Distance'
        ? sortBy([...locations], (location) =>
            location.distance && typeof location.distance.value === 'number'
              ? location.distance.value
              : Number.POSITIVE_INFINITY,
          )
        : locations;

    return sortedLocations.map((location) => formatLocationAddress({ location, country }));
  }

  const { [selectedOptionMethodKey]: { [postalCode]: cachedLocationIds } = {} } = cachedQueries;
  const mappedLocations = cachedLocationIds
    ? cachedLocationIds
        .map((id) => locationsById[id])
        .map((location) => formatLocationAddress({ location, country }))
    : undefined;

  return mappedLocations;
};

export const getSortable = ({ locations = [], sortedBy }) => {
  if (sortedBy === 'Distance') return true;
  const sortedByRecommendedIds = locations.reduce((acc, location) => acc.concat(location.id), '');
  const sortedByDistanceIds = sortBy([...locations], (location) =>
    location.distance && typeof location.distance.value === 'number'
      ? location.distance.value
      : Number.POSITIVE_INFINITY,
  ).reduce((acc, location) => acc.concat(location.id), '');
  return sortedByRecommendedIds !== sortedByDistanceIds;
};
